import { ArrowUp } from "lucide-react";

export const Footer = ({ t, scrollTo }) => (
  <footer data-testid="footer" className="bg-[#070D19] border-t border-[#C5A059]/15">
    <div className="max-w-7xl mx-auto px-6 sm:px-10 py-16">
      <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-12">
        <div>
          <span className="inline-flex items-center rounded-lg bg-[#F4EDE0] px-4 py-3 mb-6 shadow-sm">
            <img src="/assets/logo-dark.png" alt="DKT Business Account logo" className="h-16 sm:h-20 w-auto object-contain" />
          </span>
          <p className="font-display text-xl text-slate-200">DKT Business Account Ab Oy</p>
          <p className="text-sm text-slate-500 font-light mt-1">Olympiakatu 16, 65100 Vaasa, Finland</p>
          <p className="text-sm text-slate-500 font-light">FO 3631579-2</p>
          <div className="mt-5 space-y-1.5">
            <a data-testid="footer-phone-toini" href="tel:+358407490507" className="block text-sm text-slate-400 font-light hover:text-[#E6C687] transition-colors">
              Toini Malmi · +358 40 749 0507
            </a>
            <a data-testid="footer-email-toini" href="mailto:toini.malmi@dktaccounting.fi" className="block text-sm text-slate-400 font-light hover:text-[#E6C687] transition-colors">
              toini.malmi@dktaccounting.fi
            </a>
            <a data-testid="footer-phone-mikael" href="tel:+358503749614" className="block text-sm text-slate-400 font-light hover:text-[#E6C687] transition-colors">
              Mikael Knif · +358 50 374 9614
            </a>
            <a data-testid="footer-email-mikael" href="mailto:mikael.knif@dktaccounting.fi" className="block text-sm text-slate-400 font-light hover:text-[#E6C687] transition-colors">
              mikael.knif@dktaccounting.fi
            </a>
            <a data-testid="footer-email-helena" href="mailto:helena.korkeamaki@dktaccounting.fi" className="block text-sm text-slate-400 font-light hover:text-[#E6C687] transition-colors">
              Helena Korkeamäki · helena.korkeamaki@dktaccounting.fi
            </a>
            <a data-testid="footer-email-dameh" href="mailto:dameh.beh@dktaccounting.fi" className="block text-sm text-slate-400 font-light hover:text-[#E6C687] transition-colors">
              Da Meh Beh · dameh.beh@dktaccounting.fi
            </a>
          </div>
        </div>

        <div className="flex gap-16">
          <div>
            <p className="font-mono2 text-[10px] uppercase tracking-[0.25em] text-[#C5A059] mb-4">{t.footer.servicesTitle}</p>
            <ul className="space-y-2.5 text-sm text-slate-400 font-light">
              {t.services.chapters.map((c) => (
                <li key={c.n}>
                  <button data-testid={`footer-service-${c.n}`} onClick={() => scrollTo("#services")} className="hover:text-[#E6C687] transition-colors">
                    {c.title}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="font-mono2 text-[10px] uppercase tracking-[0.25em] text-[#C5A059] mb-4">{t.footer.companyTitle}</p>
            <ul className="space-y-2.5 text-sm text-slate-400 font-light">
              <li><button data-testid="footer-about-link" onClick={() => scrollTo("#about")} className="hover:text-[#E6C687] transition-colors">{t.nav.about}</button></li>
              <li><button data-testid="footer-why-link" onClick={() => scrollTo("#why")} className="hover:text-[#E6C687] transition-colors">{t.nav.why}</button></li>
              <li><button data-testid="footer-contact-link" onClick={() => scrollTo("#contact")} className="hover:text-[#E6C687] transition-colors">{t.nav.contact}</button></li>
            </ul>
          </div>
        </div>

        <button
          data-testid="footer-back-to-top"
          onClick={() => scrollTo("#top")}
          className="self-start inline-flex items-center gap-3 rounded-full border border-[#C5A059]/40 text-[#E6C687] px-5 py-2.5 text-sm hover:bg-[#C5A059]/10 transition-colors"
        >
          <ArrowUp size={16} /> {t.footer.backToTop}
        </button>
      </div>

      <div className="mt-14 pt-8 border-t border-[#C5A059]/10 flex flex-col sm:flex-row justify-between gap-3">
        <p className="font-mono2 text-[10px] uppercase tracking-[0.2em] text-slate-600">
          © 2026 DKT Business Account Ab Oy — {t.footer.rights}
        </p>
        <p className="font-mono2 text-[10px] uppercase tracking-[0.2em] text-slate-600">FI · SV · EN</p>
      </div>
    </div>
  </footer>
);
